import classNames from "classnames"
import { forwardRef, ComponentPropsWithoutRef, ReactNode, cloneElement } from "react"
import {
  BASE_CLASSES,
  BASE_DISABLED_CLASSES,
  BASE_ERROR_CLASSES,
  BASE_FOCUS_CLASSES,
} from "./constants"
import { twMerge } from "tailwind-merge"
import { FORM_COMPONENT_FOCUS_CLASSES, FOCUS_STATE_BASE_CLASSES } from "../utils/focusStateClasses"
import { isFormLabelComponent } from "../utils/isFormLabelComponent"
import { WRAPPER_CLASSES, WRAPPER_MD_CLASSES } from "../utils/formComponentWrapperClasses"

type TextAreaProps = ComponentPropsWithoutRef<"textarea"> & {
  label?: ReactNode
  error?: string
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  {
    className,
    disabled,
    error,
    id,
    label = null,
    name,
    placeholder = "Enter some text...",
    rows = 4,
    ...rest
  },
  ref,
) {
  // automatically apply id to label
  const _label = isFormLabelComponent(label)
    ? cloneElement(label, {
        htmlFor: id ?? name,
        ...label.props,
      })
    : label

  return (
    <div className={classNames(WRAPPER_CLASSES, WRAPPER_MD_CLASSES)}>
      {_label}
      <textarea
        ref={ref}
        name={name}
        id={name}
        disabled={disabled}
        className={twMerge(
          classNames(
            BASE_CLASSES,
            FOCUS_STATE_BASE_CLASSES,
            FORM_COMPONENT_FOCUS_CLASSES,
            {
              [BASE_DISABLED_CLASSES]: disabled,
              [BASE_ERROR_CLASSES]: error,
              [BASE_FOCUS_CLASSES]: !error,
            },
            className,
          ),
        )}
        rows={rows}
        placeholder={placeholder}
        {...rest}
      />
      {!!error && <span className="text-sm text-error-base">{error}</span>}
    </div>
  )
})
